import { createReducer, on } from '@ngrx/store'
import { PagoInterface } from '@shared/interfaces/app.state.interfaces'
import { pagos } from '../actions/pagos.actions'

export const initialState: PagoInterface = { idTransaccion: '' }

export const pagosReducer = createReducer(
    initialState,
    on(pagos, ((state, { item }) => {
        return { ...state, idTransaccion: item.idTransaccion }
    }))
)